import { fg } from '@atlaskit/platform-feature-flags';

import { type EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForServCoUplift({
	product,
	edition,
	isSiteEligibleToServcoUplift,
	userRoles,
	isInTrial,
	isInPredunning,
	isInCollection,
}: EditionAwarenessContextType): boolean {
	if (!fg('add_servco_uplift_touchpoint_topnav')) {
		return false;
	}

	const isJSM = product === 'jira-service-management';
	const isStandardOrPremium = edition === 'standard' || edition === 'premium';
	const isOrgAdmin = userRoles?.includes('SITE_ADMIN') ?? false;
	const isSiteEligible = isSiteEligibleToServcoUplift === true;
	const isInTrialOrPredunning = isInTrial || isInPredunning;
	const isNotInTrialOrPredunning = !isInTrialOrPredunning;

	if (fg('ea_audience_and_timing_refactor')) {
		return (
			!isInCollection &&
			isJSM &&
			isStandardOrPremium &&
			isSiteEligible &&
			isOrgAdmin &&
			isNotInTrialOrPredunning
		);
	}

	const isEligible =
		isJSM && isStandardOrPremium && isSiteEligible && isOrgAdmin && isNotInTrialOrPredunning;

	return isEligible;
}
